import "./DocumentImportExport.module.css";
import Header from "@/reusable_sections/Header";
import SystemIdentity from "./sections/SystemIdentity";
import DataIntelligenceGateway from "./sections/DataIntelligenceGateway";
import WhatDoesChange from "./sections/WhatDoesChange";
import BookYourLongueuilService from "./sections/BookYourLongueuilService";
import SolutionsBuiltForYou from "./sections/SolutionsBuiltForYou";
import Footer from "@/reusable_sections/Footer";
export default function DocumentImportExportPage() {
  return <div>
      <Header />
      <SystemIdentity />
      <SolutionsBuiltForYou />
      <WhatDoesChange />
      <BookYourLongueuilService />
      <DataIntelligenceGateway />
      <Footer />
    </div>;
}